module.exports = __webpack_public_path__ + "static/media/Source Info.87b53a01.txt";